module.exports = __webpack_public_path__ + "static/media/arrow-alt-square-right.01d36816.svg";